import styled from 'styled-components'

import {InputWrapper} from '~/components/general/input/Input.styled'

export const UrlInputRow = styled.div`
  display: flex;
  align-items: stretch;
`

export const UrlLink = styled.a`
  flex: 1;
  min-width: 0;
  display: block;
  text-decoration: none;
  color: inherit;

  &:hover {
    opacity: 0.8;
  }
`

export const UrlInputWrapper = styled(InputWrapper)`
  padding: 15px;
  font-size: ${({theme}) => theme.fontSize.lg};
  line-height: ${({theme}) => theme.lineHeight.lg};
  color: ${({theme}) => theme.colors.inputText};
  overflow-wrap: anywhere;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
`

export const CopyButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  background: ${({theme}) => theme.colors.white};
  border: 1px solid ${({theme}) => theme.colors.inputBorder};
  border-left: none;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: ${({theme}) => theme.colors.grey.grey20};
  }

  &:active {
    background: ${({theme}) => theme.colors.grey.grey50};
  }
`

export const QRCodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 24px;
  background: ${({theme}) => theme.colors.white};
  border-radius: 12px;
  border: 1px solid ${({theme}) => theme.colors.inputBorder};
`
